export enum TransitionType {
    disable = 'disable',
    enable = 'enable',
}
